/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';

import { Button, Conditional } from '@cashfree-intl/coherent';

import { EASY_SPLIT_STATUS } from '../constants';
import CustomIcon from '../../../components/CustomIcons';

function EasySplitStatus({ status, email, onTryTest, playVideo }) {
  return (
    <div className="on-demand-settlements-status-wrapper">
      <div className="text-center">
        <CustomIcon className="lock-image" componentName="LOCK" alt="lock" />
        <Conditional if={status === EASY_SPLIT_STATUS.REQUESTED}>
          <p className="normal-text text-light w-600">
            Your request for activation of Easy Split is under review.
            <br /> An email will be sent to{' '}
            <span className="text-dark">
              {email || 'your email address'}
            </span>{' '}
            after we review your request.
          </p>
          <p className="normal-text text-light w-600">
            <a
              className="on-demand-settlements-link"
              onClick={playVideo}
              data-event-name="Link_KnowMore"
            >
              Know More
            </a>{' '}
            about Easy Split
          </p>
          <Button
            primary
            type="button"
            onClick={onTryTest}
            data-event-name="Primary_Button_TryTestEnvironment"
          >
            <span className="w-600">Try Test Environment</span>
          </Button>
        </Conditional>
        <Conditional if={status === EASY_SPLIT_STATUS.HOLD}>
          <p className="normal-text text-light w-600">
            Your request for activation of Easy Split has been put on hold.{' '}
            <br />
            An email with reason for hold has been sent to{' '}
            <span className="text-dark">{email || 'your email address'}.</span>
          </p>
          <Button
            primary
            type="button"
            onClick={onTryTest}
            data-event-name="Primary_Button_TryTestEnvironment"
          >
            <span className="w-600">Try Test Environment</span>
          </Button>
        </Conditional>
      </div>
    </div>
  );
}

EasySplitStatus.propTypes = {
  status: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  onTryTest: PropTypes.func.isRequired,
  playVideo: PropTypes.func.isRequired,
};

export default EasySplitStatus;
